import { styled } from 'styled-components';

import { colors } from 'theme/theme';

import { LegacyButtonWithStyles } from './LegacyButtonWithStyles';

export const LegacyBorderlessButton = styled(LegacyButtonWithStyles)`
  color: ${colors.lightContentGrey};
  background-color: transparent;
  border-radius: 0;
`;
